import { render } from "./ProjectsComponent.vue?vue&type=template&id=7399bfbc&scoped=true"
import script from "./ProjectsComponent.vue?vue&type=script&lang=js"
export * from "./ProjectsComponent.vue?vue&type=script&lang=js"

import "./ProjectsComponent.vue?vue&type=style&index=0&id=7399bfbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7399bfbc"]])

export default __exports__